import { render, staticRenderFns } from "./delete-comment.vue?vue&type=template&id=e16e9b4e&scoped=true&"
import script from "./delete-comment.vue?vue&type=script&lang=js&"
export * from "./delete-comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16e9b4e",
  null
  
)

export default component.exports